import axios from 'axios';

const apiInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_EMBEDDED_CBC_BACKEND}/api`,
});

export default apiInstance;
